import { Box, StackProps, VStack } from 'ui/Layout';
import { Text } from 'ui/Typography';

type Props = StackProps & {
  label: string;
  children: React.ReactNode;
};

const MenuSection: React.FC<Props> = ({ label, children, ...props }) => (
  <Box>
    <Text fontSize="xs" fontWeight="medium">
      {label}
    </Text>
    <VStack alignItems="stretch" gap={2} pl={2} pt={2} {...props}>
      {children}
    </VStack>
  </Box>
);

export default MenuSection;
